
import ana from './orators/ana.webp'
import zacharoula from './orators/Andreopoulou-Zacharoula.webp'
import annette from './orators/annette.webp'
import craig from './orators/craig.webp'
import francesco from './orators/francesco.webp'
import marly from './orators/marly.webp'
import shlomo from './orators/shlomopic.webp'

import shlomo_banner from './orator_banners/shlomo.webp'
import ana_banner from './orator_banners/ana.webp'
import craig_banner from './orator_banners/craig.webp'
import annette_banner from './orator_banners/annette.webp'
import marly_banner from './orator_banners/marly.webp'
import zacharoula_banner from './orator_banners/Andreopoulou-Zacharoula.webp'
import francesco_banner from './orator_banners/Francesco-Branca.webp'

export const in_about_orators_data = [
 {
    id: "craig",
    image: craig,
    name: "Dr. Craig Watters",
    about: "Prof.",
    from: "USA",
    link: "/orator/craig",
  },
 {
    id: "zacharoula",
    image: zacharoula,
    name: "Prof. Zacharoula Andreopoulou",
    about: "Prof.",
    from: "Greece",
    link: "/orator/ana",
  }, 
  {
    id: "shlomo",
    image: shlomo,
    name: "Prof. Shlomo Nir",
    about: "Prof.",
    from: "Israel",
    link: "/orator/shlomo",
  },
  {
    id: "annette",
    image: annette,
    name: "Dr. Annette Rudolph",
    about: "Prof",
    from: "Germany",
    link: "/orator/annette",
  },
  
];



export const orators_data = [
 {
    id: "craig",
    image: craig,
    name: "Dr. Craig Watters",
    about: "Prof.",
    from: "USA",
    link: "/orator/craig",
  },
  {
    id: "ana",
    image: ana,
    name: "Prof. Ana Gago Martínez",
    about: "Prof.",
    from: "Spain",
    link: "/orator/ana",
  },
  {
    id: "shlomo",
    image: shlomo,
    name: "Prof. Shlomo Nir",
    about: "Prof.",
    from: "Israel",
    link: "/orator/shlomo",
  },
  {
    id: "marly",
    image: marly,
    name: "Prof. Marly Therese Pereira",
    about: "Prof.",
    from: "Brazil",
    link: "/orator/marly",
  },
  {
    id: "zacharoula",
    image: zacharoula,
    name: "Prof. Zacharoula Andreopoulou",
    about: "Prof.",
    from: "Greece",
    link: "/orator/zacharoula",
  }, 
  {
    id: "annette",
    image: annette,
    name: "Dr. Annette Rudolph",
    about: "Prof.",
    from: "Germany",
    link: "/orator/annette",
  },
  {
    id: "francesco",
    image: francesco,
    name: "Dr. Francesco Branca",
    about: "Prof",
    link: "/orator/francesco",
  },
];


export const craig_data = {
  image: craig,
  from: "United States",
  name: "Craig Watters",
  banner: craig_banner,
  about:
    "Craig Watters joins the School of Entrepreneurship as the Norman C. Stevenson Chair in School of Entrepreneurship in Entrepreneurship, beginning Fall 2011. Craig is an accomplished scholar, educator, entrepreneur, manager, and economic developer. He comes to OSU from the top-ranked entrepreneurship program at Syracuse University, where he has led of portfolio of educational and community engagement initiatives. He has worked with faculty across an array of disciplines on curriculum development and outreach programs related to creativity, innovation and entrepreneurship. Craig helped conceptualize and launch the highly successful South Side Entrepreneurial Connect Project, which has contributed to the transformation of an economically-challenged inner city community."
};


export const shlomo_data = {
  image: shlomo,
  from: "Israel",
  name: "Prof. Shlomo Nir",
  banner: shlomo_banner,
  about:
    "Shlomo Nir is Professor Emeritus at The Hebrew University of Jerusalem (HUJI). 1969 Ph.D-Theoretical Physics. Thesis: Atomic Spectroscopy; calculations of energy levels. 1970 Fellow, Inst. Life Sciences, HUJI.  1970-1980. RPMI, Buffalo NY. Cancer Research Scientist I-IV, and Assoc. Prof.  Biophysics; University of NY, Buffalo. 1980 Assoc. Prof. HUJI; Dept Soil and water Sciences.1985 Professor. 2003 Professor Emeritus. Recent research mainly on Water Purification. Developed models for: 1. Simultaneous adsorption of several cations(including organic caions) to surfaces, electrostatic equations and specific binding in a closed system: applied to biological membranes and clays, and extended to organic cations. 2. Particle aggregation, extent and kinetics. 3. Membrane fusion and endocytosis 4. Pore formation by peptides. 5. Kinetics of filtration for a solution with several pollutants. The model has yielded simulations and predictions for removal of chemicals and bacteria for laboratory and pilot scales. 6. Degradaion during filtration. The model, which predicts steady state phenomena was applied in (i) removal from fish ponds of off flavor compounds (ii)Very efficient purification of lake drinking water. Designed organo-clay complexes, which remove from water efficiently chemicals and microorganisms. Published 265 articles in Journals and books, 4 books, 6 patents; h-index 96."
};


export const annette_data = {
  image: annette,
  from: "Germany",
  name: "Dr. Annette Rudolph",
  banner: annette_banner,
  about:
    "Annette Rudolph initially studied mathematics (Diploma) at the Technical University of Berlin. She successfully completed her studies in 2011. She then completed her doctorate at the Institute of Meteorology at the Free University of Berlin, where she focused on geophysical fluid dynamics. There, Annette Rudolph also wrote her habilitation thesis, in which she increasingly focused on the analysis of large amounts of data. This was followed by a six-month research fellowship at the University of Oslo, during which she increasingly focused on clouds, climate, and AI. Since April 2023, she has headed the AI ​​and (Climate-Induced) Land Use Change research group at the Institute of Landscape Architecture and Environmental Planning at the TU Berlin."
};


export const andreopoulou_data = {
  image: zacharoula,
  from: "Greece",
  name: "Prof. Andreopoulou Zacharoula",
  banner: zacharoula_banner,
  about:
    "Prof. Zacharoula is an expert in forest informatics and green ICT at Aristotle University. She focuses on digital applications for sustainability, environmental governance, and rural development. B.Sc in Mathematics, Aristotle University of Thessaloniki, (1987)B.Sc. Forestry and Natural Environment, Aristotle University of Thessaloniki, (1995)Ph.D. in Forest Informatics, School of Forestry and Natural Environment, Aristotle University of Thessaloniki ,(2000)Post-doc studies & research, University of East London, UK, School of Computing and Technology (2004)Universita degli Studi di Napoli 'Parthenope', italy (2013)"
};


export const ana_data = {
  image: ana,
  from: "Spain",
  name: "Prof. Ana Gago Martínez",
  banner: ana_banner,
  about:
    "Professor at the Analytical Chemistry and Food Department of the University of Vigo, Spain and has been Director at the EU Reference Laboratory for Marine Biotoxin from 2009 to 2021. She is currently the President elect of the European Section of AOAC International. She has been involved in the development of analytical methods for marine biotoxins for more than 30 years and along this period she has been responsible for the supervision of 21 PhD students and more than 25 Master and Graduate students developing research projects in the field above mentioned and also on method development and validation for organic compounds present in complex matrices on  different fields. She has been also principal investigator of several EU and National research projects focused on the development of analytical methods for marine and freshwater toxins and more recently in projects related to the risk characterization of marine biotoxins emerging in Europe such as Tetrodotoxins and Ciguatoxins. She has also published intensively on the field of the analysis of algal toxins and other organic contaminants. She collaborates and is also involved in different International Committees and expert Panels as FAO, AOAC, EFSA, CODEX Alimentarius etc. In her role as Director of the EU Reference Laboratory of marine biotoxins, she was responsible, not only for providing support to the EU Commission, but also to coordinate and support the activities of the EU National Reference Laboratories for marine biotoxins. "
};

export const marly_data = {
  image: marly,
  from: "Brazil",
  name: "Prof. Marly Teresinha",
  banner: marly_banner,
  about:
    "She holds a degree in Agricultural Engineering (1970) and a master’s degree in Agrarian Economics (1990) from the Luiz de Queiroz College of Agriculture at the University of São Paulo, and a PhD in Studies of Latin American Societies – concentration in Sociology (2003) from the Universidad Artes y Ciéncias Sociales – ARCIS, in Santiago, Chile. She has been a Professor in the Department of Economics, Administration and Sociology at ESALQ-USP since May 1985, and Senior Professor since October 24, 2014. She was State Manager of Fisheries Extension at the State Coordination of SUDEPE/Ministry of Agriculture (1978 to 1982); State Manager of the RedeFito Mata Atlântica, of the National Program of Medicinal Plants and Phytotherapeutics – PNPMF, at the Center for Management in Biodiversity and Health – NGBS, linked to the Center for Natural Products of Farmanguinhos/Fiocruz – Ministry of Health (2007 to 20110."
};

export const francesco_data = {
  image: francesco,
  from: "Italy",
  name: "Dr. Francesco Branca",
  banner: francesco_banner,
  about:
    "Dr Francesco Branca is the Director of the Department of Nutrition for Health and Development at the World Health Organization (WHO), Geneva. He graduated in Medicine and Surgery and specialized in Diabetology and Metabolic Diseases at the Università Cattolica del Sacro Cuore, Roma. He obtained a PhD in Nutrition at Aberdeen University."
};

